import { useQuery } from 'react-query'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { languagesService } from 'src/services/languages.service'

export const initialTranslationsFilter = {
  query: '',
  locale: ['en'],
  onlyMissing: false,
  reviewRequired: false,
}

export const useTranslations = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.TRANSLATIONS, filter || initialTranslationsFilter],
    () => languagesService.getTranslations(removeDefaultParams(filter, initialTranslationsFilter)),
    {
      keepPreviousData: true,
      refetchInterval: 10000,
    },
  )
}
